import { Construtor } from './construtor';
import { Area } from './area';

export class AreaCliente implements Construtor<AreaCliente> {

    public idAreaCliente: number;
    public idCliente: number;
    public area: Area;
    public alterado: boolean;
    public selecionado: boolean;

    constructor (object?: any) {
        this.area = new Area();
        if (object !== undefined) {
            if (object instanceof (AreaCliente)) {
                this.copyObject(object);
            } else if (object instanceof Area) {
                this.area = new Area(object);
            } else {
                this.parseFromJson(object);
            }

            if (!this.modeloCompleto()) {
                return null;
            }
        }
    }

    parseFromJson(areaCliente: any): void {
        this.idAreaCliente = areaCliente.idAreaCliente;
        this.area = areaCliente.area;
        this.idCliente = areaCliente.idCliente;
    }

    copyObject(areaCliente: AreaCliente): void {
        this.idAreaCliente = areaCliente.idAreaCliente;
        this.area = areaCliente.area;
        this.idCliente = areaCliente.idCliente;
    }

    modeloCompleto(): boolean {
        return this.area !== undefined && this.idCliente !== undefined;
    }

    getNewInstance(object?: any): AreaCliente {
        return new AreaCliente(object);
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/area-cliente.ts